import { render, staticRenderFns } from "./CreateCompanyBtn.vue?vue&type=template&id=60f3ba55"
import script from "./CreateCompanyBtn.vue?vue&type=script&lang=ts"
export * from "./CreateCompanyBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports